import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import DraggableTable from '../../../ReUsableComponent/DraggableTable';
import CustomBlueButton from '../../../ReUsableComponent/CustomBlueButton';
import { getBrandReconHeaders } from '../BrandManagement.service';

const ReconReportBrand = () => {
    const USER_TOKEN = useSelector((state) => state.userAuthentication.userToken);
    const [tableRows, setTableRows] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(Date.now());


    const location = useLocation();
    const history = useHistory();

    const brand_id =
        location.state?.brand_id || localStorage.getItem("brand_id");

    if (location.state?.brand_id) {
        localStorage.setItem("brand_id", location.state.brand_id);
    }
    const brand_name =
        location.state?.brand_name || localStorage.getItem("brand_name");

    if (location.state?.brand_name) {
        localStorage.setItem("brand_name", location.state.brand_name);
    }

    // detect refresh from edit page
    // useEffect(() => {
    //     if (location.state?.refresh) {
    //         setRefreshFlag(Date.now());
    //     }
    // }, [location.state]);

    // Fetch data on page load OR when coming back from edit
    const hasFetched = useRef(false);

    useEffect(() => {
        if (!hasFetched.current) {
            fetchReconHeaders();
            hasFetched.current = true;
        }
    }, []);

    const fetchReconHeaders = () => {
        let param = `?brand=${brand_id}`;

        getBrandReconHeaders(param, USER_TOKEN)
            .then(response => {

                if (response.data.statusCode === 200) {
                    const headers = response.data.data;

                    const formatted = Object.entries(headers).map(
                        ([key, value], index) => ({
                            id: index.toString(),
                            header_key: key,
                            header_label: value.label,
                            color: value.color
                                ? `#${value.color.replace("#", "")}`
                                : "#000000",
                            name: value.name || "",
                            abbreviation: value.abbreviation || "",
                            status: Boolean(value.status), // take from API
                            checked: Boolean(value.status) // <-- checked state comes from status
                        })
                    );

                    setTableRows(formatted);

                }
            })
            .catch(err => console.log(err));
    };


    const goToEditPage = () => {
        const selectedRows = tableRows.filter(row => row.status === true);


        localStorage.setItem("edit_rows", JSON.stringify(tableRows));
        localStorage.setItem("edit_brand", brand_id);

        history.push({
            pathname: "/app/recon-report-brand-edit",
            state: {
                allRows: tableRows,
                selectedRows: tableRows.filter(r => r.status === true),
                brand: brand_id
            }
        });

    };

    return (
        <div className='notoSansFont'>
            <div className='reportTableList'>
                <div>
                    <div className='d-flex justify-content-between align-items-center montSerratFont'>
                        <div className='fontSize18 pt-3 pb-3'>Recon Report {brand_name}</div>

                        <CustomBlueButton title='Edit' onClick={goToEditPage} />
                    </div>

                    <div className='tableContainer reports'
                        style={{ maxHeight: "450px", overflowY: "auto" }}
                    >
                        <div className="tableInnerPadding">
                            <DraggableTable
                                rows={tableRows}
                                onReorder={(updated) => setTableRows(updated)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReconReportBrand;
